// Centralized color constants for FogPred application
// These are the exact values currently used throughout the application

// Fog visibility level colors
export const FOG_800M_COLOR = '#dc2626';  // red-600
export const FOG_1600M_COLOR = '#ea580c'; // orange-600
export const FOG_3000M_COLOR = '#ca8a04'; // yellow-600
export const NO_FOG_COLOR = '#16a34a';    // green-600
export const NO_DATA_COLOR = '#6b7280';   // gray-500

// Map-specific color collections
export const MAP_COLORS = {
  fog800m: FOG_800M_COLOR,
  fog1600m: FOG_1600M_COLOR,
  fog3000m: FOG_3000M_COLOR,
  noFog: NO_FOG_COLOR,
  noData: NO_DATA_COLOR,
  // Additional map colors
  defaultAirport: '#757575',
  border: '#E0E0E0',
  background: '#F5F5F5'
} as const;

// Status indicator colors
export const STATUS_COLORS = {
  actual: {
    fog800m: FOG_800M_COLOR,
    fog1600m: FOG_1600M_COLOR,
    fog3000m: FOG_3000M_COLOR,
    clear: NO_FOG_COLOR,
    noData: NO_DATA_COLOR
  },
  forecast: {
    fog800m: FOG_800M_COLOR,
    fog1600m: FOG_1600M_COLOR,
    fog3000m: FOG_3000M_COLOR,
    clear: NO_FOG_COLOR,
    noData: NO_DATA_COLOR
  }
} as const;

// Timeline colors
export const TIMELINE_COLORS = {
  grid: '#E0E0E0',
  text: '#666666',
  background: '#FFFFFF'
} as const;